/**
 * GiftRemapper
 * Flutter: lib/data/models/gift.dart
 *
 * Maps GiftStorage (SecureStorage) to GiftEntity, and raw Firestore JSON to GiftDto.
 */
import type { GiftDto } from '@/data/dtos/gift/giftDto';
import type { JsonObject } from '@/data/types/json';
import type { GiftStorage } from '@/domain/entities/secureStorage/secureStorageEntities';
import type { GiftEntity } from '@/domain/entities/gift/giftEntity';

export class GiftRemapper {
  static toStorage(dto: GiftDto): GiftStorage {
    return {
      id: dto.id,
      name: dto.name,
      description: dto.description,
      image: dto.image,
      coins: dto.coins,
      type: dto.type,
      order: dto.order,
    };
  }

  static toEntity(storage: GiftStorage): GiftEntity {
    return {
      id: storage.id,
      name: storage.name,
      description: storage.description,
      image: storage.image,
      coins: storage.coins,
      type: storage.type,
      order: storage.order,
    };
  }

  static toEntityList(storages: GiftStorage[]): GiftEntity[] {
    return storages.map(s => this.toEntity(s));
  }

  static fromJson(data: JsonObject): GiftDto {
    return {
      id: (data['id'] as string | undefined) ?? '',
      name: (data['name'] as string | undefined) ?? '',
      description: (data['description'] as string | undefined) ?? '',
      image: (data['image'] as string | undefined) ?? '',
      coins: (data['coins'] as number | undefined) ?? 0,
      type: (data['type'] as number | undefined) ?? 0,
      order: data['order'] as number | undefined,
    };
  }

  static fromJsonList(dataList: JsonObject[]): GiftDto[] {
    return dataList.map(GiftRemapper.fromJson);
  }
}
